export default __webpack_public_path__ + "static/media/1859.2076a4b9.png";